import { Api } from 'models/services/api';
import { UpdatePosSystemQuery } from 'models/services/graphql';

import { PosSystemData, PosSystemDataToSave } from '../index';

type DataToUpdate = {
  id: string;
  input: PosSystemDataToSave;
};

const RequestQuery = `
  mutation UpdatePosSystem($id: ID!, $input: PosSystemInput!) {
    ${UpdatePosSystemQuery}
  }
`;

type ResponseData = {
  data: {
    updatePosSystem: PosSystemData
  }
}

class UpdateGql {

  readonly api: Api<ResponseData>;
  readonly document?: PosSystemData;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToUpdate): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const document = api.response.data.updatePosSystem;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, api, document });
  }

}

export { UpdateGql };